export enum AnalyticsTrackingManuallyEnteredStatSource {
    Dashboard = 'dashboard',
    DetailView = 'detail view',
    Transform = 'transform',
    Other = 'other'
}
